
export default {
  name: 'AdminMobileNav',
  props: {
    active: {
      type: String,
      default: 'home'
    }
  }
}
